export const getMostRecentWednesday = (): string =>
  (d => (d.setDate(d.getDate() - (d.getDay() + 4) % 7), d.toLocaleDateString("en-CA")))(new Date());

export const getMostRecentSaturday = (): string =>
  (d => (d.setDate(d.getDate() - ((d.getDay() + 1) % 7)), d.toLocaleDateString("en-CA")))(new Date());

export const getNextMostRecentSaturday = (): string =>
  (d => (d.setDate(d.getDate() + 7 - (d.getDay() + 1) % 7), d.toLocaleDateString("en-CA")))(new Date());
